import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import Brand from "../components/Brand";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Bem-vindo de volta.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Erro ao iniciar sessão.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-black">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md glass p-10"
      >
        <Link to="/" data-testid="back-to-site"><Brand size="sm" /></Link>
        <span className="accent-rule mt-8 block" />
        <h1 className="font-display text-4xl text-[#F4EFEB] mt-5">Área reservada</h1>
        <p className="text-sm text-[#A19D98] mt-2">Inicie sessão para gerir reservas.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <Label className="text-xs uppercase tracking-[0.22em] text-[#F4EFEB]">Email</Label>
            <Input
              data-testid="input-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@lamusik.pt"
              className="mt-3 lm-input"
              required
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.22em] text-[#F4EFEB]">Palavra-passe</Label>
            <Input
              data-testid="input-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-3 lm-input"
              required
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="btn-login-submit"
            className="w-full bg-[#D45A2C] hover:bg-[#B84B23] text-white rounded-none py-6 text-xs uppercase tracking-[0.28em] font-semibold"
          >
            {loading ? "A entrar..." : "Entrar"}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
